import { loginApi, registerApi } from './apiService';

const USER_KEY = 'solarUser';

export function getUser() {
  try {
    const u = localStorage.getItem(USER_KEY);
    return u ? JSON.parse(u) : null;
  } catch {
    return null;
  }
}

export function setUser(user) {
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } else {
    localStorage.removeItem(USER_KEY);
  }
}

export function clearUser() {
  localStorage.removeItem(USER_KEY);
}

export function logout() {
  clearUser();
  localStorage.removeItem('solarRememberEmail');
}

export function isSuperAdminUser(user) {
  return !!(user && (user.role === 'SuperAdmin' || user.isSuperAdmin));
}

export async function login(email, password) {
  try {
    const data = await loginApi(email, password);
    const user = {
      id: data.id,
      name: data.name,
      organisationName: data.organisationName || '',
      role: data.role || 'User',
      isSuperAdmin: !!data.isSuperAdmin,
      email: data.email
    };
    setUser(user);
    return { ok: true };
  } catch (err) {
    const message = err.response?.data?.message || err.message || 'Invalid email or password.';
    return { ok: false, message };
  }
}

export async function register(name, organisationName, email, password) {
  try {
    const data = await registerApi(name, organisationName, email, password);
    const user = {
      id: data.id,
      name: data.name,
      organisationName: data.organisationName || '',
      role: data.role || 'User',
      isSuperAdmin: !!data.isSuperAdmin,
      email: data.email
    };
    setUser(user);
    return { ok: true };
  } catch (err) {
    const message = err.response?.data?.message || err.message || 'Registration failed.';
    return { ok: false, message };
  }
}
